export default "__VITE_ASSET__BX7TUAh6__"